import type { NextApiRequest, NextApiResponse } from 'next'
import type { GetOrderResponse } from 'ecosystem'
import { nexiApi } from 'api/utils/nexi'

export const nexiPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<GetOrderResponse | { error: string }>
) => {
  const { orderId } = req.query as { orderId: string }

  if (!orderId) {
    res.status(400).json({ error: 'OrderId was not provided' })
    return
  }

  const { error, data: nexiOrder } = await nexiApi.checkout.retrievePayment(orderId)

  if (error) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ nexiResponse: nexiOrder } as GetOrderResponse)
}
